import { render } from "./FormDropImage.vue?vue&type=template&id=08c3a9ba&scoped=true"
import script from "./FormDropImage.vue?vue&type=script&lang=js"
export * from "./FormDropImage.vue?vue&type=script&lang=js"

import "./FormDropImage.vue?vue&type=style&index=0&id=08c3a9ba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-08c3a9ba"

export default script